import { HttpErrorResponse } from '@angular/common/http';
import {
  APP_ID,
  ErrorHandler,
  Inject,
  Injectable,
  InjectionToken,
  Provider,
} from '@angular/core';
import * as Sentry from '@sentry/browser';
import { get } from 'lodash';
import { ENVIRONMENT } from './common/core/environment';

export const SENTRY_DSN = new InjectionToken<string>('SENTRY_DSN');

@Injectable()
export class SentryErrorHandler extends ErrorHandler {
  constructor(
    @Inject(APP_ID) appId: string,
    @Inject(SENTRY_DSN) dsn: string,
    @Inject(ENVIRONMENT) environment: string,
  ) {
    super();
    if (!environment.startsWith('staging') && !environment.startsWith('demo')) {
      Sentry.init({
        defaultIntegrations: [
          Sentry.browserTracingIntegration(),
          Sentry.inboundFiltersIntegration(),
          Sentry.functionToStringIntegration(),
          Sentry.globalHandlersIntegration(),
          Sentry.linkedErrorsIntegration(),
          Sentry.httpContextIntegration(),
        ],
        tracesSampleRate: 0.2,
        dsn,
        environment,
      });
      Sentry.configureScope(scope => scope.setTag('app', appId));
    }
  }

  excludedHttpError(e: HttpErrorResponse) {
    const excludedStatuses = [401, 403];
    if (!(e instanceof HttpErrorResponse)) return false;
    else if (excludedStatuses.includes(e.status)) {
      return true;
    } else return false;
  }

  handleError(error: any) {
    let e = error.orginalError || error;
    if (!(e instanceof Error)) {
      e = new Error(
        `Caught object of type ${get(
          e,
          'constructor.name',
          'unknown',
        )} with data: ${JSON.stringify(e)}`,
      );
    }
    if (!this.excludedHttpError(error.orginalError || error))
      Sentry.captureException(e);
    super.handleError(e);
  }
}

export const SENTRY_PROVIDERS: Provider[] = [
  { provide: ErrorHandler, useClass: SentryErrorHandler },
];
